import { useEffect, useState } from "react";
export function ReportsView() {
  const [data, setData] = useState<{
    summary?: {
      revenue: string;
      deals: number;
      average_days?: number;
      ready?: number | null;
      overdue?: number | null;
    };
    managers: { full_name: string; deals: number }[];
  }>({ managers: [] });
  useEffect(() => {
    fetch("/api/reports")
      .then((response) => (response.ok ? response.json() : { managers: [] }))
      .then(setData);
  }, []);
  return (
    <section className="module-view" data-amazi-id={"crm/src/features/crm/reports-view.tsx:19:5"}>
      <div className="module-heading" data-amazi-id={"crm/src/features/crm/reports-view.tsx:20:7"}>
        <div data-amazi-id={"crm/src/features/crm/reports-view.tsx:21:9"}>
          <div className="breadcrumb" data-amazi-id={"crm/src/features/crm/reports-view.tsx:22:11"}>
            Рабочее пространство <span data-amazi-id={"crm/src/features/crm/reports-view.tsx:23:34"}>/</span> Отчёты
          </div>
          <h1 data-amazi-id={"crm/src/features/crm/reports-view.tsx:25:11"}>Отчёты ателье</h1>
          <p data-amazi-id={"crm/src/features/crm/reports-view.tsx:26:11"}>Готовность заказов, просрочки и загрузка мастеров</p>
        </div>
        <button className="select-button" data-amazi-id={"crm/src/features/crm/reports-view.tsx:28:9"}>
          Июнь 2024 <span data-amazi-id={"crm/src/features/crm/reports-view.tsx:29:21"}>⌄</span>
        </button>
      </div>
      <div className="report-stats" data-amazi-id={"crm/src/features/crm/reports-view.tsx:32:7"}>
        <div className="panel" data-amazi-id={"crm/src/features/crm/reports-view.tsx:33:9"}>
          <span data-amazi-id={"crm/src/features/crm/reports-view.tsx:34:11"}>Выручка отдела</span>
          <strong data-amazi-id={"crm/src/features/crm/reports-view.tsx:35:11"}>₽ {data.summary?.revenue ?? "0"}</strong>
          <em data-amazi-id={"crm/src/features/crm/reports-view.tsx:36:11"}>По данным ателье</em>
        </div>
        <div className="panel" data-amazi-id={"crm/src/features/crm/reports-view.tsx:38:9"}>
          <span data-amazi-id={"crm/src/features/crm/reports-view.tsx:39:11"}>Выдано заказов</span>
          <strong data-amazi-id={"crm/src/features/crm/reports-view.tsx:40:11"}>{data.summary?.deals ?? 0}</strong>
          <em data-amazi-id={"crm/src/features/crm/reports-view.tsx:41:11"}>По данным ателье</em>
        </div>
        <div className="panel" data-amazi-id={"crm/src/features/crm/reports-view.tsx:43:9"}>
          <span data-amazi-id={"crm/src/features/crm/reports-view.tsx:44:11"}>Средний срок заказа</span>
          <strong data-amazi-id={"crm/src/features/crm/reports-view.tsx:45:11"}>{data.summary?.average_days ?? 0} дней</strong>
          <em data-amazi-id={"crm/src/features/crm/reports-view.tsx:46:11"}>По датам заказов</em>
        </div>
      </div>
      <div className="panel report-panel" data-amazi-id={"crm/src/features/crm/reports-view.tsx:49:7"}>
        <h2 data-amazi-id={"crm/src/features/crm/reports-view.tsx:50:9"}>Загрузка мастеров</h2>
        <p data-amazi-id={"crm/src/features/crm/reports-view.tsx:51:9"}>Заказы в работе и соблюдение сроков</p>
        <div className="table-head report-head" data-amazi-id={"crm/src/features/crm/reports-view.tsx:52:9"}>
          <span data-amazi-id={"crm/src/features/crm/reports-view.tsx:53:11"}>Мастер</span>
          <span data-amazi-id={"crm/src/features/crm/reports-view.tsx:54:11"}>Заказы</span>
          <span data-amazi-id={"crm/src/features/crm/reports-view.tsx:55:11"}>Заказы в работе</span>
          <span data-amazi-id={"crm/src/features/crm/reports-view.tsx:56:11"}>Загрузка</span>
        </div>
        {data.managers.length === 0 && <div className="empty-message" data-amazi-id={"crm/src/features/crm/reports-view.tsx:58:40"}>Нет данных для отчёта.</div>}
        {data.managers.map((member) => (
          <div className="report-row" key={member.full_name} data-amazi-id={"crm/src/features/crm/reports-view.tsx:60:11"}>
            <span className="client-name" data-amazi-id={"crm/src/features/crm/reports-view.tsx:61:13"}>
              <i className="avatar avatar-purple" data-amazi-id={"crm/src/features/crm/reports-view.tsx:62:15"}>{member.full_name.slice(0, 2)}</i>
              <strong data-amazi-id={"crm/src/features/crm/reports-view.tsx:63:15"}>{member.full_name}</strong>
            </span>
            <span data-amazi-id={"crm/src/features/crm/reports-view.tsx:65:13"}>{member.deals}</span>
            <span data-amazi-id={"crm/src/features/crm/reports-view.tsx:66:13"}>{member.deals}</span>
            <span className="result-bar" data-amazi-id={"crm/src/features/crm/reports-view.tsx:67:13"}>
              <i style={{ width: "0%" }} data-amazi-id={"crm/src/features/crm/reports-view.tsx:68:15"} />
            </span>
          </div>
        ))}
      </div>
    </section>
  );
}
